export const iconFontAwesomeEnergyPoop = (
	<i className="fa-solid fa-poop"></i>
);
